import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../../main-component/CaptainTCCards/CaptainTCCards.css";
import tRewardsImg from "../../images/captain-tc/t-rewards.png";

const ImageMagnifier = ({
  src,
  alt,
  containerStyle = {},
  imageStyle = {},
  disableOnDesktop = false,
}) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [position, setPosition] = useState({ x: 50, y: 50 });
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const shouldMagnify = disableOnDesktop ? isMobile : true;
  const activeMagnifier = showMagnifier && shouldMagnify;

  const handleMouseMove = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setPosition({ x, y });
  };

  return (
    <>
      <div
        className="magnifier-container"
        onMouseEnter={() => setShowMagnifier(true)}
        onMouseLeave={() => setShowMagnifier(false)}
        onMouseMove={handleMouseMove}
        onClick={() => setShowMagnifier(true)}
        style={{
          position: "relative",
          overflow: "hidden",
          width: "180px",
          height: "240px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "8px",
          cursor: shouldMagnify ? "pointer" : "default",
          transform: activeMagnifier ? "scale(1.8)" : "scale(1)",
          zIndex: activeMagnifier ? 20 : 1,
          transition: "transform 0.2s ease-out",
          ...containerStyle,
        }}
      >
        <img
          src={src}
          alt={alt}
          className="magnifier-image"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            transform: activeMagnifier ? "scale(1)" : "scale(1)",
            transformOrigin: `${position.x}% ${position.y}%`,
            transition: activeMagnifier
              ? "transform 0.1s ease-out"
              : "transform 0.3s ease-out",
            pointerEvents: "none",
            ...imageStyle,
          }}
        />
      </div>

      {/* Mobile Center Modal via Portal to prevent z-index/transform stacking issues */}
      {activeMagnifier &&
        typeof document !== "undefined" &&
        createPortal(
          <div
            className="mobile-magnifier-modal"
            onClick={() => setShowMagnifier(false)}
          >
            <img
              src={src}
              alt={alt + " Full"}
              className="mobile-magnifier-image"
            />
            <div className="mobile-magnifier-close">Tap to close</div>
          </div>,
          document.body,
        )}
    </>
  );
};

const CaptainTCTRewardsContent = () => {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        lineHeight: "1.6",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <ImageMagnifier
          src={tRewardsImg}
          alt="Captain TC (T) Rewards Card"
          disableOnDesktop={false}
          containerStyle={{
            width: "100%",
            maxWidth: "60%",
            height: "auto",
            borderRadius: "10px",
            margin: "0 auto",
          }}
          imageStyle={{
            height: "auto",
          }}
        />
      </div>

      <div style={{ marginTop: "20px", color: "#CCCEEF" }}>
        <h2
          style={{
            textAlign: "center",
            color: "#CCCEEF",
            fontSize: "28px",
            fontWeight: "bold",
            margin: "0 0 10px 0",
          }}
        >
          CAPTAIN TC (T) REWARDS
        </h2>
        <h3
          style={{
            textAlign: "center",

            fontSize: "22px",
            fontWeight: "bold",
            margin: "0 0 20px 0",
          }}
        >
          UP TO £500 TOTAL REWARDS
        </h3>

        <p
          style={{
            fontSize: "18px",
            marginBottom: "25px",
            textAlign: "center",
            lineHeight: "1.6",
          }}
        >
          Complete 5,000 qualifying Reward Topcoin and the applicable qualifying Topcoin requirements to qualify for up to £500 in total rewards.
        </p>

        <div
          style={{
            border: "1px solid #ccceef",
            color: "#ccceef",
            padding: "14px 20px",
            margin: "20px auto 25px auto",
            maxWidth: "600px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
            lineHeight: "1.6",
          }}
        >
          <div>£425 Captain TC (T) Rewards</div>
          <div>+ £25 Captain TC (T) Topcoin Reward</div>
          <div>+ Up to £50 Original Topcoin & Bonus Rewards</div>
          <div>= UP TO £500 TOTAL REWARDS</div>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            £425 CAPTAIN TC (T) REWARDS
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            Earn £21.25 in (T) Rewards for every 250 qualifying Reward Topcoin completed. Complete all 20 qualifying stages up to 5,000 Reward Topcoin to qualify for the full £425 Captain TC (T) Reward.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            PLUS £25 CAPTAIN TC (T) TOPCOIN REWARD
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            Complete the applicable qualifying requirements to qualify for an additional £25 Captain TC (T) Topcoin Reward.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            PLUS UP TO £50 ORIGINAL TOPCOIN & BONUS REWARDS
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            Complete the applicable qualifying requirements in your original TopCoin Wallet to qualify for up to £50 in Original Topcoin & Bonus Rewards.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            HOW REWARD TOPCOIN WORKS
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            For every standard qualifying Topcoin you receive in your original TopCoin Wallet, you will receive the same number of Reward Topcoin in your Captain TC Rewards Wallet.
          </p>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              textAlign: "center",
              marginBottom: "8px",
            }}
          >
            1 qualifying standard Topcoin = 1 Reward Topcoin
          </p>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            Bonus Topcoin are excluded from the Reward Topcoin matching calculation.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            PLUS UP TO £4,000 IN ADDITIONAL CAPTAIN TC GOLD CARD REWARDS*
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            Your Captain TC (T) Rewards Card also gives you access to collect Captain TC Gold Cards on qualifying product purchases from participating companies on the TopCoin UK platform. Collect 20 qualifying Captain TC Gold Cards to qualify for a £16 Captain TC Gold Card Reward. Continue collecting qualifying Captain TC Gold Cards in accordance with the programme to qualify for up to £4,000 in additional Captain TC Gold Card Rewards.
          </p>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            Captain TC Gold Card Rewards are a separate additional reward opportunity and are subject to their applicable qualifying requirements.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            EXCLUSIVE (T) REWARDS
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            These rewards are available exclusively with the Captain TC (T) Rewards Card, subject to the applicable qualifying requirements.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            GET YOUR FREE (T) REWARDS CARD
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            Receive a FREE Captain TC (T) Rewards Card with a qualifying purchase from a participating company on the TopCoin UK platform.
          </p>
        </div>

        <div
          style={{
            border: "1px solid #CCCEEF",
            padding: "20px",
            color: "#CCCEEF",
            fontWeight: "bold",
            fontSize: "16px",
            textAlign: "center",
            maxWidth: "700px",
            margin: "30px auto 20px auto",
          }}
        >
          FREE (T) Rewards Card &bull; Valid for 36 months from activation &bull; A new card is required after expiry to continue earning rewards.
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            5,000 REWARD TOPCOIN PER CARD
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            Each Captain TC (T) Rewards Card is valid for up to 5,000 qualifying Reward Topcoin. Once you complete 5,000 qualifying Reward Topcoin, that card's Reward Topcoin progression is complete. A new eligible Captain TC Rewards Card is required to continue earning rewards under a new card progression.
          </p>
        </div>

        <div style={{ margin: "25px 0" }}>
          <h4
            style={{
              textAlign: "center",
              color: "#CCCEEF",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            ONE ACTIVE CAPTAIN TC REWARDS CARD AT A TIME
          </h4>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "0",
              textAlign: "center",
            }}
          >
            You can have only one active Captain TC Rewards Card at a time: (T) - Copper - Bronze - Silver - Gold.
          </p>
        </div>

        <p
          style={{
            fontSize: "13px",
            textAlign: "center",
            color: "#CCCEEF",
            opacity: 0.7,
            marginTop: "20px",
            marginBottom: "15px",
          }}
        >
          Rewards are subject to qualifying activity, verification and applicable TopCoin UK programme terms.
        </p>

        {/* <div style={{ textAlign: "center", marginTop: "15px" }}>
          <a
            href="/documents/Captain_TC_T_Rewards_500_Updated.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#0d6efd",
              fontWeight: "bold",
              textDecoration: "underline",
              fontSize: "15px",
            }}
          >
            View Official Captain TC (T) Rewards Document (PDF)
          </a>
        </div> */}

        
      </div>
    </div>
  );
};

export default CaptainTCTRewardsContent;
